import {httpsCallable} from 'firebase/functions';
import {auth, functions} from '../firebase';

export function createCitizenScienceTutorialApi(uid, {preview = false} = {}) {
  const request = async data => {
    // Capture the account that owns this lesson; do not retry as a new user.
    if (auth.currentUser?.uid !== uid) throw new Error('Your account changed. Reopen the game.');
    const result = await httpsCallable(functions, 'citizenScienceTutorial', {timeout: 30000})(data);
    if (auth.currentUser?.uid !== uid) throw new Error('Your account changed. Reopen the game.');
    return result.data;
  };
  return {
    load: () => request({action: preview ? 'preview' : 'get'}),
    answer: value => request({...value, action: preview ? 'preview-answer' : 'answer'}),
    skip: () => preview ? Promise.resolve({skipped: true, preview: true}) : request({action: 'skip'}),
  };
}
